import PANOLENS from 'panolens.js';

const Panoramic = {
    bindEvents: () => {
        const panoramic = document.getElementsByClassName('sib-panolens');
        if (panoramic[0]) {
            Panoramic.init(panoramic);
        }
    },
    init: (panoramic) => {
        const overlay = document.getElementsByClassName('sib-panolens__overlay');
        // Panoramic.start(panoramic);

        for (let i = 0; i < panoramic.length; i++) {
            overlay[i].addEventListener('click', () => {
                overlay[i].style.zIndex = -1;

                const currentPano = overlay[i].nextElementSibling.nextElementSibling;
                Panoramic.viewer[i].control.noZoom = true;
                if (currentPano.getAttribute('data-type') === 'video') {
                    Panoramic.viewer[i].toggleVideoPlay();
                }
            });
        }
    },
    start: (panoramic) => {
        let PAN = PANOLENS;
        let panorama;
        Panoramic.viewer = [];
        for (let i = 0; i < panoramic.length; i++) {
            const type = panoramic[i].getAttribute('data-type');
            if (type === 'video') {
                // panorama = new PAN.VideoPanorama('/web/images/All_Website_2K_Vimeo.mp4');
            } else {
                panorama = new PAN.ImagePanorama('/web/images/Exhibition_4K_0100.jpg');
            }

            Panoramic.viewer[i] = new PAN.Viewer({
                container: panoramic[i],
                controlBar: false,
            });
            Panoramic.viewer[i].add(panorama);
            Panoramic.viewer[i].OrbitControls.noZoom = true;
            Panoramic.viewer[i].control.noZoom = true;
        }
    },
};

module.exports = Panoramic;



// WEBPACK FOOTER //
// ./src/js/partials/panolens.js